/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate HTTP proxy
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.22.0-beta.6-6-gfde9e530-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ExternalHostsInfoFromJSON, ExternalHostsInfoToJSON, } from './ExternalHostsInfo';
import { SetupStateFromJSON, SetupStateToJSON, } from './SetupState';
import { PortsInfoFromJSON, PortsInfoToJSON, } from './PortsInfo';
import { AdminPermissionsFromJSON, AdminPermissionsToJSON, } from './AdminPermissions';
/**
 * Check if a given object implements the Info interface.
 */
export function instanceOfInfo(value) {
    if (!('ports' in value) || value['ports'] === undefined)
        return false;
    if (!('minimizePasswordLogin' in value) || value['minimizePasswordLogin'] === undefined)
        return false;
    if (!('authorizedViaTicket' in value) || value['authorizedViaTicket'] === undefined)
        return false;
    if (!('authorizedViaSsoWithSingleLogout' in value) || value['authorizedViaSsoWithSingleLogout'] === undefined)
        return false;
    if (!('ownCredentialManagementAllowed' in value) || value['ownCredentialManagementAllowed'] === undefined)
        return false;
    if (!('hasLdap' in value) || value['hasLdap'] === undefined)
        return false;
    return true;
}
export function InfoFromJSON(json) {
    return InfoFromJSONTyped(json, false);
}
export function InfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'version': json['version'] == null ? undefined : json['version'],
        'username': json['username'] == null ? undefined : json['username'],
        'selectedTarget': json['selected_target'] == null ? undefined : json['selected_target'],
        'externalHost': json['external_host'] == null ? undefined : json['external_host'],
        'externalHosts': json['external_hosts'] == null ? undefined : ExternalHostsInfoFromJSON(json['external_hosts']),
        'ports': PortsInfoFromJSON(json['ports']),
        'minimizePasswordLogin': json['minimize_password_login'],
        'authorizedViaTicket': json['authorized_via_ticket'],
        'authorizedViaSsoWithSingleLogout': json['authorized_via_sso_with_single_logout'],
        'ownCredentialManagementAllowed': json['own_credential_management_allowed'],
        'hasLdap': json['has_ldap'],
        'setupState': json['setup_state'] == null ? undefined : SetupStateFromJSON(json['setup_state']),
        'adminPermissions': json['admin_permissions'] == null ? undefined : AdminPermissionsFromJSON(json['admin_permissions']),
        'runningOnEc2': json['running_on_ec2'] == null ? undefined : json['running_on_ec2'],
    };
}
export function InfoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'version': value['version'],
        'username': value['username'],
        'selected_target': value['selectedTarget'],
        'external_host': value['externalHost'],
        'external_hosts': ExternalHostsInfoToJSON(value['externalHosts']),
        'ports': PortsInfoToJSON(value['ports']),
        'minimize_password_login': value['minimizePasswordLogin'],
        'authorized_via_ticket': value['authorizedViaTicket'],
        'authorized_via_sso_with_single_logout': value['authorizedViaSsoWithSingleLogout'],
        'own_credential_management_allowed': value['ownCredentialManagementAllowed'],
        'has_ldap': value['hasLdap'],
        'setup_state': SetupStateToJSON(value['setupState']),
        'admin_permissions': AdminPermissionsToJSON(value['adminPermissions']),
        'running_on_ec2': value['runningOnEc2'],
    };
}
